import '../../shared/src/i18n/init';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { theme } from './theme/theme';
import { registerServiceWorker } from '../../shared/src/utils/registerServiceWorker';

registerServiceWorker(__BASE_PATH__);

const root = createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter basename={__BASE_PATH__.replace(/\/$/, '') || '/'}>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
);
